export class AnalyticsEvent {
  eventName: string;
  properties?: any;
}
